const Detail = () => (
  <div className="py-16 px-4 md:px-8 xl:px-24">
    <p className="w-full xl:w-1/2 mx-auto text-center md:pb-24 text-xs md:text-base xl:text-lg font-normal text-black">
      By keeping business goals & User’s frustration in mind, we provided all
      the basic as well as advance features in the app which could help users
      before even they start working with new customers.
    </p>
  </div>
);

export default Detail;
